import React from 'react';
import '../../styles/GridBoxes.css';
import map from '../../assets/Maps/1.jpg';
import { Link } from 'react-router-dom';
// import dummy4 from '../../assets/dummy4.jpg';

export default function SecondaryBox1 (props) {

  return (
    <div className='box'>
        <h1>{props.SecondaryBoxTitle1}</h1>
        <Link to="/map">
        <img src={map} alt="" />
        </Link>
    </div>
  );
};